import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-x"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "small" }
const _hoisted_9 = {
  key: 0,
  class: "muted small"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "small"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$props.docs.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($data.images.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.verified_files($data.images), (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "gallery-panel",
                    key: image.name
                  }, [
                    _createElementVNode("a", {
                      href: image.file_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: image.file_url
                      }, null, 8 /* PROPS */, _hoisted_3)
                    ], 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("div", {
                      class: "file-remove",
                      onClick: $event => ($options.remove(image))
                    }, _hoisted_6, 8 /* PROPS */, _hoisted_4)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.__("No images for this document")), 1 /* TEXT */)
              ]))
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.docs, (doc) => {
          return (_openBlock(), _createElementBlock("div", {
            key: doc.name
          }, [
            ($props.docs.length > 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.frappe.datetime.obj_to_user(doc.start_datetime)) + " : " + _toDisplayString(doc.gardener), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($options.verified_files(doc.files).length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass($props.small ? 'gallery small-images' : 'gallery')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.verified_files(doc.files), (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "gallery-panel",
                      key: image.name
                    }, [
                      _createElementVNode("a", {
                        href: image.file_url,
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: image.file_url
                        }, null, 8 /* PROPS */, _hoisted_11)
                      ], 8 /* PROPS */, _hoisted_10)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.__("No images for this maintenance")), 1 /* TEXT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}